import { useState, useEffect } from "react";
import { useFormik } from "formik";
import usePfqAxios from "./usePfqAxios";
import Constants from "../Constants";

export default function useCaseNotes(caseId, initialNotes = {}) {
    const [isNoteDialogOpen, setNoteDialogOpen] = useState(false);
    const [isAllNoteViewOpen, setAllNoteViewOpen] = useState(false);
    const [notes, setNotes] = useState(initialNotes || {});

    const { postData, isLoading: getNotesLoading, deleteData } = usePfqAxios();

    useEffect(() => {
        setNotes(initialNotes || []);
    }, [initialNotes]);

    const submitNote = async (values) => {
        const noteData = {
            caseId,
            text: values.note,
        };

        try {
            const res = await postData(Constants.ApiUrl.note.addNote, JSON.stringify({ noteData }));
            setNotes(res.data);
            setNoteDialogOpen(false);
        } catch (err) {
            console.error("Failed to add note:", err);
        }
    };

    const noteFormik = useFormik({
        initialValues: { note: "" },
        onSubmit: submitNote,
    });

    useEffect(() => {
        if (isNoteDialogOpen) noteFormik.resetForm();
    }, [isNoteDialogOpen]);

    const deleteNote = async (noteId) => {
        try {
            const res = await deleteData(`${Constants.ApiUrl.note.deleteNote}/${noteId}`);
            setNotes(res.data);
        } catch (err) {
            console.error("Failed to delete note:", err);
        }
    };

    return {
        isNoteDialogOpen,
        setNoteDialogOpen,
        isAllNoteViewOpen,
        setAllNoteViewOpen,
        notes,
        noteFormik,
        deleteNote,
        getNotesLoading
    };
}